export default __webpack_public_path__ + "static/SRUS SBL702 - Especification Del Producto y Datos Técnicos-6bdc33e38b937405afb85800ebb6c715.pdf";